import React from 'react';

import { Dialog } from '@neptune/shared/venus-ui';

import ContactSales from 'components/contact-sales/ContactSales';

export const AlreadyAnAdminModal: React.FC<{
  isOpen: boolean;
  close: () => void;
}> = ({ isOpen, close }) => {
  return (
    <Dialog
      isOpen={isOpen}
      title="Cannot change access rights"
      primaryButtonLabel="OK"
      onPrimaryButtonClick={close}
      onClose={close}
    >
      <Dialog.Text>
        User is already administrating another team workspace in the free trial subscription. To be
        able to grant Admin rights to this user,{' '}
        <span onClick={close}>
          <ContactSales>contact sales</ContactSales>
        </span>
        .
      </Dialog.Text>
    </Dialog>
  );
};
